import React, { useState, useEffect, useContext } from 'react';
import './CollectionsOfCategory.css';
import './spinner.css';
import { useParams } from 'react-router-dom';
import { searchByPrice, SearchByBrandName, fetchSearchData, fetchCategoryWiseData, sortingViaPrice } from '../../driver';
import FilterBlock from './FilterBlock/FilterBlock';
import CategoryBlock from './CategoryBlock/CategoryBlock';
import { collectionContext } from '../../App';
import { useNavigate } from 'react-router-dom';
import { useCategoryDataQuery, useGetSearchDataQuery } from '../../features/api/apiSlice';

const CollectionsOfCategory = ({ setCurrentCrumbs }) => {

    const { type, searchValue } = useParams();
    const { value4, value5, value6 } = useContext(collectionContext);
    const [searchItem] = value4;
    const [page, setPage] = value5;
    const [, setSearchLoading] = value6;
    const [currentStatus, setCurrentStatus] = useState('');
    const [range, setRange] = useState([]);
    const [notFound, setNotFound] = useState(false);
    const [brand, setBrand] = useState([]);
    const [viewStatus, setViewStatus] = useState('');
    const [documentsData, setDocumentsData] = useState([]);
    const [productData, setProductData] = useState([])
    const navigate = useNavigate();

    let pd = [];
    let brandNameList = []


    const { data: getSearchData, isLoading, isError } = useGetSearchDataQuery({
        searchValue,
        page
    });
    

    const { data: categoryData, isLoading: categoryLoading } = useCategoryDataQuery({ type, page });

    
    useEffect(() => {
        if (type) {
            fetchCategoryWiseData(categoryData, {
                setSearchLoading,
                setProductData,
                setDocumentsData
            })
        } else if (searchItem?.length > 0) {
            fetchSearchData(searchValue, { setSearchLoading, setProductData, setDocumentsData }, getSearchData, navigate);
        }
        // eslint-disable-next-line
    }, [type, searchValue, page, categoryData, getSearchData])


    useEffect(() => {
        searchByPrice(range, productData, pd);
        SearchByBrandName(brand, productData, brandNameList);

        pd.length === 0 && range.length > 0 ? setNotFound(true) : setNotFound(false);
        // eslint-disable-next-line
    }, [type, range, brand])

    const currentData = getSearchData?.afterSplice?.length > 0 ? getSearchData?.afterSplice : categoryData?.afterSplice;


    useEffect(() => {
        // Set initial layout
        setViewStatus('grid');

        // Set initial crumbs
        setCurrentCrumbs(type);
        // Soring product
        sortingViaPrice(currentStatus, { getSearchData, categoryData, currentData }, { setProductData });

    }, [currentStatus, getSearchData, categoryData, type, currentData, setCurrentCrumbs]);

    

    // Describe what to do render
    let content = null;
    if (isLoading || categoryLoading) content = <div className="loading">Loading&#8230;</div>

    if (!isLoading && !isError && getSearchData?.afterSplice?.length === 0) content = <div className='not-found'>Sorry, Product Not found!</div>

    if (!isLoading && (currentData?.length > 0)) {
        content = <div className="container mt-4 collection-categories">
            <div className="row">

                <FilterBlock range={range} setRange={setRange} brand={brand} setBrand={setBrand} />

                <CategoryBlock productList={productData} type={type} setCurrentStatus={setCurrentStatus} viewStatus={viewStatus} setViewStatus={setViewStatus} notFound={notFound} setPage={setPage} documentsData={documentsData} />
            </div>
        </div>
    }

    return (
        content
    );
};

export default CollectionsOfCategory;